import { BriefcaseBusiness, Home, MessageCircle } from "lucide-react";
import Reveal from "@/components/Reveal";

const steps = [
  { icon: BriefcaseBusiness, number: "01", title: "Pick a real-life scenario", copy: "Bring an interview answer, a workplace meeting, or a conversation you need to handle in Canada." },
  { icon: MessageCircle, number: "02", title: "Practise live in a group of 6", copy: "Say the words out loud, get warm guidance, and learn the Canadian phrasing that makes the moment feel natural." },
  { icon: Home, number: "03", title: "Leave ready for tomorrow", copy: "Take practical phrases into your next conversation with a landlord, neighbour, hiring manager, or colleague." },
];

const SessionWalkthroughSection = () => (
  <section className="session-walkthrough-section section-space" aria-labelledby="session-walkthrough-title" data-testid="session-walkthrough-section">
    <Reveal className="section-inner">
      <div className="walkthrough-heading-row"><div><div className="section-kicker">WHAT A SESSION LOOKS LIKE</div><h2 id="session-walkthrough-title">Less theory. More useful English.</h2></div><p>Every lesson begins with the situation you want to navigate and ends with language you can use immediately.</p></div>
      <div className="walkthrough-grid">
        {steps.map(({ icon: Icon, number, title, copy }) => <article className="walkthrough-card" key={number} data-testid={`walkthrough-step-${number}`}><div className="walkthrough-card-top"><span>{number}</span><Icon size={20} aria-hidden="true" /></div><h3>{title}</h3><p>{copy}</p></article>)}
      </div>
    </Reveal>
  </section>
);

export default SessionWalkthroughSection;
